module.exports = __webpack_public_path__ + "static/media/laptop-mobile.a701a971.svg";